module.exports = __webpack_public_path__ + "img/multiplier.5b6d0d88.png";